module.exports = __webpack_public_path__ + "img/border_rectangle.f1502c05.svg";